import React from 'react';
import * as S from '../locations-finder.styles';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { ForceOrderTypeToggleButton } from 'components/new-order/order-type-selector/order-type-selector.styles';
import { useFieldNames } from 'components/new-order/useFieldNames.hooks';
import { useFormContext } from 'react-hook-form';

const ForceOrderTypeSelectPanel = ({ types, setSelectedForceOrderType }) => {
  const { t } = useTranslation();
  const { fieldNames } = useFieldNames();
  const { setValue } = useFormContext();

  return (
    <S.Container
      data-testid="LocationsFinderOrderType.Container"
      flexDirection="column"
      alignItems="center"
      p={2}
    >
      <Box mb={1}>
        <S.ForcedOrderTypeTitle variant="h5" component="h1">
          {t('locations.forceOrderType.label')}
        </S.ForcedOrderTypeTitle>
      </Box>
      <Box
        component="ul"
        p={0}
        m={0}
        width="100%"
        sx={{ listStyle: 'none' }}
        data-testid="OrderTypeSelector.CircleToggleGroup"
      >
        {types.map(({ label, type, ...rest }) => (
          <Box component="li" key={type}>
            <ForceOrderTypeToggleButton
              {...rest}
              fullWidth
              onChange={(_e, newValue) => {
                setValue(fieldNames.orderType, type);
                setSelectedForceOrderType(type);
              }}
            >
              {label}
            </ForceOrderTypeToggleButton>
          </Box>
        ))}
      </Box>
    </S.Container>
  );
};

export default ForceOrderTypeSelectPanel;
